import { DoCheck, AfterViewInit, Component, OnInit, AfterContentChecked, AfterContentInit } from '@angular/core';
import { Criterios } from '../interfaces/Criterios';
import { MAERLPARAM } from '../interfaces/MAERLPARAM';
import { MAERL } from '../interfaces/MAERL';
import { Message, MessageService, SelectItem } from 'primeng/api';
import { ReportesService } from '../servicios/reporte.service';
import { ErroresBaseDatosService } from '../servicios/errores-base-datos.service';
import { NuevoComponentService } from '../servicios/nuevo-component.service';
import { ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  // styleUrls: ['./reportes.component.css']
  styleUrls: ['../advantage/styles/saciwebtrn.css']
})
export class ReportesComponent implements OnInit {
  indicador: any;
  parametrosEjecutar: Criterios[];
  criteriosEjecutar: Criterios[];
  criteriosreporte: MAERLPARAM[];
  reporte: MAERL[] = [];
  etiquetas: Criterios[];
  etiquetas2: Criterios[];
  dialogovisible: boolean;
  reporteSeleccionado: MAERL;
  types: SelectItem[];
  arregloBus: any[];
  displayDialogBus: boolean;
  displayDialogBusCriterio: boolean;
  displayDialogBusquedaFast: boolean;
  query: string;
  index: number;
  opcion: string;
  etiquetaSeleccionada: Criterios;
  mensaje: string;
  msgs: Message[];
  excel: boolean;
  titulo: string;

  where: string;
  tabla: string;
  busquedacampos: any[];
  datawarehouse: any;//GSRF
  spin: boolean = false;

  constructor(private reporteSer: ReportesService, private messageService: MessageService,
    private errorService: ErroresBaseDatosService, private init: NuevoComponentService) {
  }

  ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1];
    this.parametrosEjecutar = [];
    this.criteriosEjecutar = [];
    this.dialogovisible = false;
    this.etiquetas = [];
    this.etiquetas2 = [];
    this.criteriosreporte = [];
    this.reporteSeleccionado = {};
    this.displayDialogBus = false;
    this.displayDialogBusCriterio = false;
    this.displayDialogBusquedaFast = false;
    this.types = [];
    this.index = 0;
    this.arregloBus = [];
    this.query = '';
    this.opcion = '';
    this.mensaje = '';
    this.msgs = [];
    console.log(this.indicador);
    this.datawarehouse=this.indicador.label;

    if (this.indicador.labelmenu === 'Reportes') {
      this.titulo = 'Reportes ' + this.indicador.label;
      this.reporteSer.obtenerGrupo(this.indicador.label, this.indicador.modprefijo).subscribe((respues) => {
        let opcodigo = 0;
        if (respues[0] !== undefined) {
          opcodigo = respues[0].OPCCODIGO;
        }
        if (opcodigo !== 1) {
          this.reporteSer.mandarSentenciaReportes(opcodigo, 'R').subscribe((respuesta: any[]) => {
            this.reporte = respuesta;
            for (const rs of this.reporte) {
              rs.RL_NOMBRESUBSTR = rs.RL_NOMBRE.substr(3);
            }
            this.reporteSeleccionado = this.reporte[0];
          });
        }
      });
    }

    if (this.indicador.labelmenu === 'Listados') {
      this.titulo = 'Listados ' + this.indicador.label;
      this.reporteSer.obtenerGrupoLis(this.indicador.label, this.indicador.modprefijo).subscribe((respues) => {
        let opcodigo = 0;
        if (respues[0] !== undefined) {
          opcodigo = respues[0].OPCCODIGO;
        }
        if (opcodigo !== 1 && opcodigo !== 0) {
          this.reporteSer.mandarSentenciaReportes(opcodigo, 'L').subscribe((respuesta: any[]) => {
            this.reporte = respuesta;
            for (const rs of this.reporte) {
              rs.RL_NOMBRESUBSTR = rs.RL_NOMBRE.substr(3);
            }
            this.reporteSeleccionado = this.reporte[0];
          });
        }
      });
    }
  }

  /*ngDoCheck(): void {
    if (this.reporteSer.returnCodigo() !== 1) {
      this.reporteSer.mandarSentenciaReportes(this.reporteSer.returnCodigo()).subscribe((respuesta: any[]) => {
        this.reporte = respuesta;
        this.reporteSeleccionado = this.reporte[0];
        this.reporteSer.recibirCodigo(1);
      });
    }
  }*/


  async ejecutarReporte() {
    this.mensaje = '';
    this.msgs = [];
    console.log(this.reporteSeleccionado);
    if (this.reporteSeleccionado.RL_PROCESO !== null) {
      if (this.reporteSeleccionado.RL_PROCEDENCIA === 'V') {
        this.mensaje = 'Proceso generado con vista';
        this.msgs.push({ severity: 'success', summary: '', detail: this.mensaje });
      } else {
        try {
          await this.reporteSer.ejecutarProcedureSNOrden(this.etiquetas2, this.etiquetas, this.reporteSeleccionado, this.criteriosreporte);
          this.mensaje = 'Ejecución exitosa';
          this.msgs.push({ severity: 'success', summary: '', detail: this.mensaje });
        } catch (error1) {
          let mensaje: string;
          //mensaje = this.errorService.generarMensajeErrorCompleto(error1.error);
          this.mensaje = 'Error al ejecutar el proceso';
          this.msgs.push({ severity: 'error', summary: '', detail: this.mensaje });
          this.spin=false
        }
      }
    } else {
      this.mensaje = 'No existe proceso';
      this.msgs.push({ severity: 'success', summary: '', detail: this.mensaje });
    }
  }
async ejecutarReportedatawarehouse(){
  this.mensaje = '';
    this.msgs = [];
    console.log(this.reporteSeleccionado);
    if (this.reporteSeleccionado.RL_PROCESO !== null) {
      if (this.reporteSeleccionado.RL_PROCEDENCIA === 'V') {
        this.mensaje = 'Proceso generado con vista';
        this.msgs.push({ severity: 'success', summary: '', detail: this.mensaje });
      } else {
        try {
          await this.reporteSer.ejecutarProcedureSNOrdenDW(this.etiquetas2, this.etiquetas, this.reporteSeleccionado, this.criteriosreporte);
          this.mensaje = 'Ejecución exitosa';
          this.msgs.push({ severity: 'success', summary: '', detail: this.mensaje });
        } catch (error1) {
          let mensaje: string;
          //mensaje = this.errorService.generarMensajeErrorCompleto(error1.error);
          this.mensaje = 'Error al ejecutar el proceso';
          this.msgs.push({ severity: 'error', summary: '', detail: this.mensaje });
          this.spin=false
        }
      }
    } else {
      this.mensaje = 'No existe proceso';
      this.msgs.push({ severity: 'success', summary: '', detail: this.mensaje });
    }
}
  async mandarinforeporte(reporte) {
    this.reporteSeleccionado = reporte;
    this.reporteSeleccionado.RL_ARCHIVO = this.reporteSeleccionado.RL_ARCHIVO.replace(' ', '_');
    this.reporteSeleccionado.RL_ARCHIVO = this.reporteSeleccionado.RL_ARCHIVO.replace(' ', '_');
    this.reporteSeleccionado.RL_ARCHIVO = this.reporteSeleccionado.RL_ARCHIVO.replace(' ', '_');
    await this.abrirdialogo('boton');
  }

  async abrirdialogo(aux) {
    this.msgs = [];
    this.etiquetas = [];
    this.etiquetas2 = [];
    console.log(this.reporteSeleccionado);
    if (this.reporteSeleccionado.RL_CODIGO === undefined) {
      this.messageService.add({
        key: 'reporte',
        severity: 'error',
        summary: 'Error',
        detail: 'No selecionó un reporte'
      });
    } else {
      const respuesta = await this.reporteSer.mandarSentenciaParametros(this.reporteSeleccionado);
      this.criteriosreporte = respuesta;
      // console.log(this.criteriosreporte);
      let i = 0;
      let button: string;
      let button2: string;
      do {
        if (this.criteriosreporte[i].RLP_TIPOVARIABLE === null) {
          this.criteriosreporte[i].RLP_TIPOVARIABLE = '';
        }
        if (this.criteriosreporte[i].RLP_TIPOVARIABLE.includes('P') && this.criteriosreporte[i].RLP_ETIQUETA !== null) {
          if (this.criteriosreporte[i].RLP_CONSULTA === null && this.criteriosreporte[i].RLP_TIPO === 'D') {
            button = 'D';

            this.etiquetas.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA !== null && this.criteriosreporte[i].RLP_TIPO === 'D') {
            button = 'DC';

            this.etiquetas.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA === null && this.criteriosreporte[i].RLP_TIPO === 'I') {
            button = 'I';

            this.etiquetas.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA !== null && this.criteriosreporte[i].RLP_TIPO === 'I') {
            button = 'IC';

            this.etiquetas.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA === null && this.criteriosreporte[i].RLP_TIPO === 'S') {
            button = 'S';

            this.etiquetas.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA !== null && this.criteriosreporte[i].RLP_TIPO === 'S') {
            button = 'SC';

            this.etiquetas.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else {
            console.log('error');
          }

          // console.log(this.criteriosreporte[i].RLP_ETIQUETA);
        }
        if (this.criteriosreporte[i].RLP_TIPOVARIABLE.includes('C') && this.criteriosreporte[i].RLP_ETIQUETA !== null) {
          if (this.criteriosreporte[i].RLP_CONSULTA === null && this.criteriosreporte[i].RLP_TIPO === 'D') {
            button = 'D';
            button2 = 'D2';
            this.etiquetas2.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA,
              parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '',
              boton1: button,
              parametro2: this.criteriosreporte[i + 1] === undefined ? '' : this.criteriosreporte[i + 1].RLP_PARAMETRO,
              campo2: '',
              boton2: button2,
              consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA !== null && this.criteriosreporte[i].RLP_TIPO === 'D') {
            button = 'DC';
            button2 = 'DC2';
            this.etiquetas2.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, parametro2: this.criteriosreporte[i + 1].RLP_PARAMETRO, campo2: '', boton2: button2,
              consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA === null && this.criteriosreporte[i].RLP_TIPO === 'I') {
            button = 'I';
            button2 = 'I2';
            this.etiquetas2.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, parametro2: this.criteriosreporte[i + 1].RLP_PARAMETRO, campo2: '', boton2: button2,
              consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA !== null && this.criteriosreporte[i].RLP_TIPO === 'I') {
            button = 'IC';
            button2 = 'IC2';
            this.etiquetas2.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, parametro2: this.criteriosreporte[i + 1].RLP_PARAMETRO, campo2: '', boton2: button2,
              consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA === null && this.criteriosreporte[i].RLP_TIPO === 'S') {
            button = 'S';
            button2 = 'S2';
            this.etiquetas2.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, parametro2: this.criteriosreporte[i + 1].RLP_PARAMETRO, campo2: '', boton2: button2,
              consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else if (this.criteriosreporte[i].RLP_CONSULTA !== null && this.criteriosreporte[i].RLP_TIPO === 'S') {
            button = 'SC';
            button2 = 'SC2';
            this.etiquetas2.push({
              label: this.criteriosreporte[i].RLP_ETIQUETA, parametro1: this.criteriosreporte[i].RLP_PARAMETRO,
              campo1: '', boton1: button, parametro2: this.criteriosreporte[i + 1].RLP_PARAMETRO, campo2: '', boton2: button2,
              consulta: this.criteriosreporte[i].RLP_CONSULTA
            });
            // console.log(button);
          } else {
            console.log('error');
          }
        }

        i++;
      } while (this.criteriosreporte.length > i);
      if (aux === 'boton') {
        this.dialogovisible = true;
      }
      if (aux === 'ejecutar') {
        await this.ejecutarReporte();
      }
    }

  }

  cerrar() {
    this.init.tabs.splice(this.init.tabindex, 1);
  }

  salir() {
    this.dialogovisible = false;
    this.etiquetas = [];
    this.etiquetas2 = [];
  }

  salirBus() {
    this.types = [];
    this.displayDialogBus = false;
    this.displayDialogBusquedaFast = false;
  }

  busquedadatosanterior(a, opcion) {
    this.opcion = opcion;
    this.query = a.consulta;
    this.busqueda(this.query);
  }

  busquedadatos(a, opcion) {

    this.opcion = opcion;
    this.query = a.consultacrit;

    const consulta = String(a.consulta).toUpperCase();
    console.log(consulta);
    let from = ''
    let orderby=''//CDPJ
    let distinct='';//CDPJ
    let where='';//CDPJ
    if (a.consulta.includes('FROM')) {
      from = a.consulta.substr(a.consulta.indexOf(' FROM ') + 6);
    }
    
    //CDPJ
    if(a.consulta.includes('ORDER BY')){
      orderby=consulta.substr(consulta.indexOf(' ORDER BY ') + 9);
    }
    if(a.consulta.includes('DISTINCT')){
      distinct=' DISTINCT ';
    }
    if(a.consulta.includes(' WHERE ')){
      let b=consulta.indexOf(' WHERE ');
    let c=consulta.indexOf(' ORDER BY ')
    let d=Number(c)-Number(b)
    where=consulta.substr(consulta.indexOf(' WHERE ')+7,d-6);
    }
    //CDPJ
    const tabla = from.substr(0, from.indexOf(' '));
    this.tabla = tabla;

    let campos = '';
    campos = consulta.substr(consulta.indexOf('SELECT') + 6, consulta.indexOf(' FROM ') - 6).replace(' DISTINCT ', '');//INCLUÍ .replace(' DISTINCT ', '') CDPJ
    console.log(campos);
    const separador = campos.split(',');
    console.log(separador);
    const columns = [];
    const names = [];
    for (const s of separador) {
      columns.push(s.substr(0, s.indexOf(' AS')).replace(' ', ''));
      names.push(s.substr(s.indexOf(' AS') + 3).replace(' ', ''));
    }
    let armarconsulta = 'SELECT ';
     //CDPJ
     if(distinct !== ''){
      armarconsulta= armarconsulta + distinct;
    }
    //CDPJ
    let i = 0;
    for (const rs of columns) {
      if (i === 0) {
        armarconsulta = armarconsulta + rs;
      } else {
        armarconsulta = armarconsulta + ',' + rs;
      }
      i++;
    }
    if(where !==''){
      armarconsulta = armarconsulta + ' FROM ' + this.tabla +' WHERE ' +where+' ';
    }else{
      armarconsulta = armarconsulta + ' FROM ' + this.tabla //+ '   WHERE ROWNUM<50';
    }
    
    if(orderby !== ''){
      armarconsulta = armarconsulta + ' ORDER BY '+orderby;//CDPJ + ' ORDER BY '+orderby
    }
    console.log(armarconsulta);//CDPJ
    this.busquedafast(armarconsulta, columns, names);
  }

  busqueda(query) {
    this.reporteSer.mandarSentenciaBusqueda(query).subscribe((respuesta: any[]) => {
      this.arregloBus = respuesta;
      for (let key2 in respuesta[0]) {
        this.types.push({ label: key2, value: key2 });
      }
      console.log(this.types);
      this.displayDialogBus = true;
      console.log(this.types);
    });
  }

  busquedafast(query, columns, names) {
    this.where = '';
    this.types = [];
    this.busquedacampos = [];
    console.log(columns);
    this.reporteSer.mandarSentenciaBusqueda(query).subscribe((respuesta: any[]) => {
      this.arregloBus = respuesta;
      let i = 0;
      for (let key2 in respuesta[0]) {
        this.types.push({ label: names[i], value: columns[i] });
        this.busquedacampos.push('');
        i++;
      }
      this.displayDialogBusquedaFast = true;
    });
  }

  recibirParam(parametro) {
    if (this.index === 0) {
      if (this.opcion === 'SC') {
        console.log(parametro);
        for (let key in parametro) {
          this.etiquetas2[this.etiquetas2.indexOf(this.etiquetaSeleccionada)].campo1 = parametro[key];
          break;
        }
      } else if (this.opcion === 'SC2') {
        for (let key2 in parametro) {
          this.etiquetas2[this.etiquetas2.indexOf(this.etiquetaSeleccionada)].campo2 = parametro[key2];
          break;
        }
      } else if (this.opcion === 'DC') {
        for (let key in parametro) {
          this.etiquetas2[this.etiquetas2.indexOf(this.etiquetaSeleccionada)].campo1 = parametro[key];
          break;
        }
      } else if (this.opcion === 'DC2') {
        for (let key2 in parametro) {
          this.etiquetas2[this.etiquetas2.indexOf(this.etiquetaSeleccionada)].campo2 = parametro[key2];
          break;
        }
      } else if (this.opcion === 'IC') {
        for (let key in parametro) {
          this.etiquetas2[this.etiquetas2.indexOf(this.etiquetaSeleccionada)].campo1 = parametro[key];
          break;
        }
      } else if (this.opcion === 'IC2') {
        for (let key2 in parametro) {
          this.etiquetas2[this.etiquetas2.indexOf(this.etiquetaSeleccionada)].campo2 = parametro[key2];
          break;
        }
      }
      this.salirBus();
    } else if (this.index === 1) {
      if (this.opcion === 'SC') {
        for (let key in parametro) {
          this.etiquetas[this.etiquetas.indexOf(this.etiquetaSeleccionada)].campo1 = parametro[key];
          break;
        }
      } else if (this.opcion === 'SC2') {
        for (let key2 in parametro) {
          this.etiquetas[this.etiquetas.indexOf(this.etiquetaSeleccionada)].campo2 = parametro[key2];
          break;
        }
      } else if (this.opcion === 'DC') {
        for (let key in parametro) {
          this.etiquetas[this.etiquetas.indexOf(this.etiquetaSeleccionada)].campo1 = parametro[key];
          break;
        }
      } else if (this.opcion === 'DC2') {
        for (let key2 in parametro) {
          this.etiquetas[this.etiquetas.indexOf(this.etiquetaSeleccionada)].campo2 = parametro[key2];
          break;
        }
      } else if (this.opcion === 'IC') {
        for (let key in parametro) {
          this.etiquetas[this.etiquetas.indexOf(this.etiquetaSeleccionada)].campo1 = parametro[key];
          break;
        }
      } else if (this.opcion === 'IC2') {
        for (let key2 in parametro) {
          this.etiquetas[this.etiquetas.indexOf(this.etiquetaSeleccionada)].campo2 = parametro[key2];
          break;
        }
      }
    }
    this.types = [];
    this.salirBus();
  }

  seleccion(etiqueta) {
    this.etiquetaSeleccionada = etiqueta;
  }

  async descargarReporte(modo) {
    if (this.spin === true) {
      this.messageService.add({
        key: 'reporte',
        severity: 'error',
        summary: 'Error',
        detail: 'Proceso en ejecución'
      });
      return;
    }

    this.spin = true;
    if (modo === 'directo') {
      this.excel = false;
      await this.abrirdialogo('ejecutar');
    }
    if (modo === 'excel') {
      this.excel = true;
      await this.abrirdialogo('ejecutar');
    }
    if (modo === 'parametros') {
      this.excel = false;
      await this.ejecutarReporte();
    }
    if (modo === 'parametrosexcel') {
      this.excel = true;
      await this.ejecutarReporte();
    }
    //GSRF
    if (modo === 'parametrosdatawarehouse') {
      this.excel = false;
      await this.ejecutarReportedatawarehouse();
      this.spin = false;
      return;
    }
    if (modo === 'exportdatawarehouse') {
      this.excel = false;
      await this.descargacsv();
      this.spin = false;
      return;
    }
    //GSRF
    let strPantallaArchivoRP = '';
    if (this.excel === true) {
      let NOMBREREPORTE = this.reporteSeleccionado.RL_ARCHIVO;
      NOMBREREPORTE = NOMBREREPORTE.substr(0, NOMBREREPORTE.length - 7);
      strPantallaArchivoRP = NOMBREREPORTE + '_XLS.jasper';
    } else {
      strPantallaArchivoRP = this.reporteSeleccionado.RL_ARCHIVO;
    }

    let unirSQLTotal = '';
    if (this.reporteSeleccionado.RL_PROCEDENCIA === "V") {
      let strQuerryCriterios = this.FormarQueryVistaCrit();
      let strQuerryParametro = this.FormarQueryVistaParam();
      let intQuerryCriterios = strQuerryCriterios.length;
      let intQuerryParametro = strQuerryParametro.length;
      if (intQuerryCriterios == 0 && intQuerryParametro > 0) {
        unirSQLTotal = "AND(" + strQuerryParametro.substring(4) + ")";
      }
      if (intQuerryCriterios == 0 && intQuerryParametro == 0) {
        unirSQLTotal = "";
      }
      if (intQuerryCriterios > 0 && intQuerryParametro >= 0) {
        unirSQLTotal = "AND(" + this.FormarQueryVistaCrit() + this.FormarQueryVistaParam() + ")";
      }
    }
    this.spin = false;
    this.reporteSer.generarLiReporte(strPantallaArchivoRP, '', this.excel, unirSQLTotal,this.reporteSeleccionado.RL_CODIGO).subscribe(response => {
      //console.log(response);
      let base64: string = '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';
      base64 = response;
      if (this.excel === true) {
        let byteCharacters = atob(base64);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          let slice = byteCharacters.slice(offset, offset + 512);
          let byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          let bytearray = new Uint8Array(byteNumbers);
          byteArrays.push(bytearray);
        }
        let blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('style', 'display: none;');
        a.href = fileURL;
        a.download = strPantallaArchivoRP + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(fileURL);
      } else {
        const mediaType = 'application/pdf';
        const blob = new Blob([response], { type: mediaType });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      }
      if (this.reporteSeleccionado.RL_OBJETO.toString().includes('TMP')) {
        this.reporteSer.eliminarTabla(this.reporteSeleccionado.RL_OBJETO).subscribe(data => {
        });
      }
    }, error => {
      this.messageService.add({
        key: 'reporte',
        severity: 'error',
        summary: 'Error',
        detail: 'Error al generar el reporte. Inténtelo después de un momento'
      });
    });

  }

  async descargarReporte2(aux) {
    await this.abrirdialogo('ejecutar');

    let NOMBREREPORTE: string;
    let urlreporte: string;
    let usuarioEsquema: any;
    let esquema: string;
    let src: string;

    urlreporte = sessionStorage.getItem('urlreporte');
    usuarioEsquema = JSON.parse(sessionStorage.getItem('usuarioEsquema'));
    esquema = usuarioEsquema.esquema;
    NOMBREREPORTE = '';
    NOMBREREPORTE = this.reporteSeleccionado.RL_ARCHIVO;
    NOMBREREPORTE = NOMBREREPORTE.substr(0, NOMBREREPORTE.length - 7);
    src = urlreporte + NOMBREREPORTE + '.pdf?j_username=' + esquema + '&j_password=jasperadmin';
    console.log(src);

    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = src;
    document.body.appendChild(link);
    link.click();
    link.remove();

  }

  FormarQueryVistaCrit(): string {
    let union = "";
    let union1 = "";
    let strSQLConsulta = "";
    let strCodigoCampo = "";
    let strTabla = "";
    let strCriterioInicio = "";
    let strCriterioFinal = "";
    let item: MAERLPARAM;
    console.log(this.etiquetas2)
    console.log(this.criteriosreporte)
    for (const etiqueta of this.etiquetas2) {
      strCodigoCampo = '';
      strTabla = '';
      
      for (const data of this.criteriosreporte) {
        if (data.RLP_PARAMETRO === etiqueta.parametro1) {
          item = data;
          strCodigoCampo = item.RLP_PARAMETRO;
          strTabla = item.RLP_TABLA;
          console.log('1',item)
        }
      }
      if (item.RLP_TIPOVARIABLE !== 'P') {
        if (item.RLP_TIPO === "S") {
          strCriterioInicio = "'" + etiqueta.campo1 + "'";
          strCriterioFinal = "'" + etiqueta.campo2 + "'";
          if ((strCriterioInicio === null || strCriterioInicio === "''") &&
            !(strCriterioFinal === null || strCriterioFinal === "''")) {
            strCriterioInicio = strCriterioFinal;
          }
          if (!(strCriterioInicio === null || strCriterioInicio === "''") &&
            (strCriterioFinal === null || strCriterioFinal === "''")) {
            strCriterioFinal = strCriterioInicio;
          }
          if ((strCriterioInicio === null || strCriterioInicio === "''") &&
            (strCriterioFinal === null || strCriterioFinal === "''")) {
            union = strSQLConsulta;
          }
          if (!(strCriterioInicio === null || strCriterioInicio === "''") &&
            !(strCriterioFinal === null || strCriterioFinal === "''")) {
            union1 = " AND " + strTabla + "." + strCodigoCampo + " BETWEEN " + strCriterioInicio + " AND " + strCriterioFinal;
            union = union + union1;
          }
          console.log(union);
        }
        if (item.RLP_TIPO === "D") {
          if (etiqueta.campo1 !== null) {
            strCriterioInicio = "'" + etiqueta.campo1 + "'";
          } else {
            strCriterioInicio = null;
          }
          if (etiqueta.campo1 !== null) {
            strCriterioFinal = "'" + etiqueta.campo2 + "'";
          } else {
            strCriterioFinal = null;
          }

          if (!(strCriterioInicio === null || strCriterioInicio === "''") &&
            !(strCriterioFinal === null || strCriterioFinal === "''")) {
            union1 = " AND TO_DATE(TO_CHAR(" + strTabla + "." + strCodigoCampo + ",'DD/MM/YYYY'),'DD/MM/YYYY')" +
              " BETWEEN TO_DATE(" + strCriterioInicio + ",'DD/MM/YYYY')" + " AND TO_DATE(" + strCriterioFinal + ",'DD/MM/YYYY')";
            union = union + union1;
          }
          if ((strCriterioInicio === null || strCriterioInicio === "''") &&
            !(strCriterioFinal === null || strCriterioFinal === "''")) {
            union1 = " AND TO_DATE(TO_CHAR(" + strTabla + "." + strCodigoCampo + ",'DD/MM/YYYY'),'DD/MM/YYYY')" +
              " <= TO_DATE(" + strCriterioFinal + ",'DD/MM/YYYY')";
            union = union + union1;
          }
          if (!(strCriterioInicio === null || strCriterioInicio === "''") &&
            (strCriterioFinal === null || strCriterioFinal === "''")) {
            union1 = " AND TO_DATE(TO_CHAR(" + strTabla + "." + strCodigoCampo + ",'DD/MM/YYYY'),'DD/MM/YYYY')" +
              " >= TO_DATE(" + strCriterioInicio + ",'DD/MM/YYYY')";
            union = union + union1;
          }
          if ((strCriterioInicio === null || strCriterioInicio === "''") &&
            (strCriterioFinal === null || strCriterioFinal === "''")) {
            union = strSQLConsulta;
          }
        }
        if (item.RLP_TIPO === "I") {
          console.log('2')
          strCriterioInicio = " " + etiqueta.campo1 + " ";
          strCriterioFinal = " " + etiqueta.campo2 + " ";
          strCriterioFinal=strCriterioFinal.toString().trim()===''?null:strCriterioFinal
          strCriterioInicio=strCriterioInicio.toString().trim()===''?null:strCriterioInicio
          console.log('3',strCriterioInicio)
          console.log('4',strCriterioFinal)
          if ((strCriterioInicio === null || strCriterioInicio === "''") &&
            !(strCriterioFinal === null || strCriterioFinal === "''")) {
            strCriterioInicio = strCriterioFinal;
          }
          if (!(strCriterioInicio === null || strCriterioInicio === "''") &&
            (strCriterioFinal === null || strCriterioFinal === "''")) {
            strCriterioFinal = strCriterioInicio;
          }
          if ((strCriterioInicio === null || strCriterioInicio === "''") &&
            (strCriterioFinal === null || strCriterioFinal === "''")) {
            union = strSQLConsulta;
          }
          if (!(strCriterioInicio === null || strCriterioInicio === "''") &&
            !(strCriterioFinal === null || strCriterioFinal === "''")) {
            union1 = " AND " + strTabla + "." + strCodigoCampo + " BETWEEN " + strCriterioInicio + " AND " + strCriterioFinal;
            union = union + union1;
          }
          // if (strCriterioInicio === null && !strCriterioFinal === null) {
          //   console.log('5')
          //   strCriterioInicio = strCriterioFinal;
          // }
          // if (!strCriterioInicio === null && strCriterioFinal === null) {
          //   console.log('6')
          //   strCriterioFinal = strCriterioInicio;
          // }
          // if (strCriterioInicio === null && strCriterioFinal === null) {
          //   console.log('7')
          //   union = strSQLConsulta;
          // }
          // console.log(!strCriterioInicio)
          // console.log(!strCriterioFinal)
          // if (!strCriterioInicio === null && !strCriterioFinal === null) {
          //   console.log('8')
          //   union1 = " AND " + strTabla + "." + strCodigoCampo + " BETWEEN " + strCriterioInicio + " AND " + strCriterioFinal;
          //   union = union + union1;
          // }
        }
      }

      strSQLConsulta = union;
      console.log('9',strSQLConsulta)
    }

    if (union.length > 2) {
      strSQLConsulta = union.substring(4);
      //strSQLConsulta = union.substring(3);
    }
    console.log(strSQLConsulta)
    return strSQLConsulta;
  }

  FormarQueryVistaParam(): string {
    let union = "";
    let union1 = "";
    let strSQLConsulta = "";
    let strCodigoCampo = "";
    let strTabla = "";
    let strParametro = "";
    let item: MAERLPARAM;
    for (const etiqueta of this.etiquetas) {
      strCodigoCampo = '';
      strTabla = '';
      for (const data of this.criteriosreporte) {
        if (data.RLP_PARAMETRO === etiqueta.parametro1) {
          item = data;
          strCodigoCampo = item.RLP_PARAMETRO;
          strTabla = item.RLP_TABLA;
        }
      }
      if (item.RLP_TIPOVARIABLE === 'P') {
        if (item.RLP_TIPO === "S" || item.RLP_TIPO === "D") {
          strParametro = "'" + etiqueta.campo1 + "'";
        }
        if (item.RLP_TIPO === "I") {
          strParametro = " " + etiqueta.campo1 + " ";
        }
        if (strParametro === null || strParametro === "''") {
          union1 = "";
        }
        else {
          if (item.RLP_TIPO === "D") {
            union1 = " AND TO_DATE(TO_CHAR(" + strTabla + "." + strCodigoCampo + ",'DD/MM/YYYY'),'DD/MM/YYYY')" + "= TO_DATE(" + strTabla + "." + strParametro + ",'DD/MM/YYYY')";
          }
          if (item.RLP_TIPO !== "D") {
            union1 = " AND " + strTabla + "." + strCodigoCampo + "=" + strParametro;
          }
        }
        union = union + union1;
      }
    }
    strSQLConsulta = union;
    return strSQLConsulta;
  }
   //GSRF
   async descargacsv() {
    const res1 = await this.reporteSer.mandarSentenciabi(this.reporteSeleccionado);//GSRF
    console.log('<<<<<>>><',res1);
    for(let aux of res1 ){
      const archivo = await this.reporteSer.ejecutarsentcsv(aux.RLP_CONSULTA);
      console.log('<<<<<>>><',archivo);
      const campos = Object.keys(archivo[0]);
      //console.log('<<<<<>>><',campos);
      const csvString = campos.join(',') + '\n' +
          archivo.map((dato)=> campos.map((campo)=>dato[campo]).join(',')).join('\n');
        //console.log('<<<<<>>><',csvString);
        const blob = new Blob([csvString], {type: 'text/csv'});
        const element = document.createElement('a');
        element.setAttribute('download', aux.RLP_NOMBRE);
        element.setAttribute('href', window.URL.createObjectURL(blob));
        element.click();
    }
      

  }
  //GSRF
}


